import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";

const ChatSideBar = ({
  chats,
  onSelectChat,
  newChat,
  isSidebarVisible,
  toggleSidebar,
  isLoading,
}) => {
  const { tabId } = useParams(); // Get current tabId from URL

  return (
    <div
      className={`chat-sidebar bg-light ${
        isSidebarVisible ? "sidebar-visible" : ""
      }`}
    >
      <div className="sidebar-header px-2 border-bottom d-flex justify-content-between mt-3">
        <button className="btn new-chat-btn mt-lg-3" onClick={newChat}>
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          New Chat
        </button>
        <span className="d-md-none fs-1 ms-2 mt-1" onClick={toggleSidebar}>
          &#9776;
        </span>
      </div>
      {isLoading ? (
        <div className="text-center pt-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <ul className="chat-history-wrapper d-flex flex-column p-0 m-0">
          {chats.map((chat) => (
            <li
              key={chat.tabId}
              className={`tabs-item mb-0 px-3 py-2 ${
                String(tabId) === String(chat.tabId) ? "active" : ""
              }`}
              onClick={() => onSelectChat(chat.tabId)}
            >
              {chat.title}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ChatSideBar;
